import { createAction, props } from '@ngrx/store';
import { ShipmentIssue, ShipmentIssueListResponse, ShipmentIssueFilter } from '../../data/interfaces';

export const loadShipmentIssues = createAction(
  '[Shipment Issues] Load Shipment Issues',
  props<{ filter: ShipmentIssueFilter }>()
);

export const loadShipmentIssuesSuccess = createAction(
  '[Shipment Issues] Load Shipment Issues Success',
  props<{ shipmentIssues: ShipmentIssueListResponse }>()
);

export const loadShipmentIssuesFailure = createAction(
  '[Shipment Issues] Load Shipment Issues Failure',
  props<{ error: string }>()
);

export const createShipmentIssue = createAction(
  '[Shipment Issues] Create Shipment Issue',
  props<{ shipmentIssue: Partial<ShipmentIssue> }>()
);

export const createShipmentIssueSuccess = createAction(
  '[Shipment Issues] Create Shipment Issue Success',
  props<{ shipmentIssue: ShipmentIssue }>()
);

export const createShipmentIssueFailure = createAction(
  '[Shipment Issues] Create Shipment Issue Failure',
  props<{ error: string }>()
);

export const updateShipmentIssue = createAction(
  '[Shipment Issues] Update Shipment Issue',
  props<{ id: string; updates: Partial<ShipmentIssue> }>()
);

export const updateShipmentIssueSuccess = createAction(
  '[Shipment Issues] Update Shipment Issue Success',
  props<{ shipmentIssue: ShipmentIssue }>()
);

export const updateShipmentIssueFailure = createAction(
  '[Shipment Issues] Update Shipment Issue Failure',
  props<{ error: string }>()
);

export const deleteShipmentIssue = createAction(
  '[Shipment Issues] Delete Shipment Issue',
  props<{ id: string }>()
);

export const deleteShipmentIssueSuccess = createAction(
  '[Shipment Issues] Delete Shipment Issue Success',
  props<{ id: string }>()
);

export const deleteShipmentIssueFailure = createAction(
  '[Shipment Issues] Delete Shipment Issue Failure',
  props<{ error: string }>()
);
